import { defineStore } from 'pinia'
import moment from "moment";

export const CurrentYear = defineStore('zn_c_year', {
    state: () => {
        return { zn_c_year: parseInt(moment().format('YYYY')) }
    },
    actions: {
        get() {
            return this.zn_c_year
        },
        set(data) {
            this.zn_c_year = data
        }
    },
})